import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FAQsTable from "./FAQsTable";
import { getFAQs } from "../../store/AsyncMethods/FAQsMethod";
import { usePermissions } from "../../permissions/PermissionContext";

export default function FAQsMain() {
  const { canOpen } = usePermissions();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user } = useSelector((state) => state.AuthReducer);

  useEffect(() => {
    if (user) {
      dispatch(getFAQs());
    }
  }, []);

  return (
    <div className="mx-3">
      <div className="flex justify-end">
        {canOpen("/add-faqs") && (
          <Button
            label="Add FAQs"
            icon="pi pi-plus"
            className="p-primary-btn"
            onClick={() => navigate("/add-faqs")}
          />
        )}
      </div>

      <div className="my-4">
        <FAQsTable />
      </div>
    </div>
  );
}
